<template>
  <div class="w-100 text-center my-2">
    <span v-if="baseCluesCount !== null">
      {{
        $t('fences.status.summary', {
          total: totalVisibleClues,
          base: baseCluesCount,
          extra: extraClues,
        })
      }}
    </span>

    <i
      id="popover-fences-status"
      class="fas fa-info-circle ml-1"
      style="cursor: pointer"
    />

    <d-popover target="popover-fences-status" placement="top" triggers="hover">
      <template slot="title">{{ $t('fences.status.legendTitle') }}</template>

      <ul class="mb-0 pl-0 clues-legend" style="list-style-type: none">
        <li>
          <span class="clue-dot" :style="{ background: EDGE_COLORS.fixed }" />
          {{ $t('fences.status.fixedClues', { count: baseCluesCount }) }}
        </li>
        <li>
          <span class="clue-dot" :style="{ background: EDGE_COLORS.extra }" />
          {{ $t('fences.status.extraClues', { count: extraClues }) }}
        </li>
        <li v-if="settings.showAnswer">
          <span class="clue-dot" :style="{ background: EDGE_COLORS.path }" />
          {{ $t('fences.status.answerVisible') }}
        </li>
        <li v-else>
          <span class="clue-dot clue-dot--hidden" />
          {{ $t('fences.status.answerHidden') }}
        </li>
      </ul>
    </d-popover>
  </div>
</template>

<script>
import { EDGE_COLORS } from './PuzzleFencesModel';

export default {
  name: 'FencesStatusAndPopover',
  data() {
    return { EDGE_COLORS };
  },
  props: {
    baseCluesCount: {
      type: Number,
      default: 0,
    },
    extraClues: {
      type: Number,
      default: 0,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalVisibleClues() {
      return (this.baseCluesCount || 0) + (Number(this.extraClues) || 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.clues-legend {
  font-size: 14px;
  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
}
.clue-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  &--hidden {
    background: #cccccc;
    border: 1px dashed #999999;
  }
}
</style>
